import { IState } from "@common/state/IState";
import { ISubscriptionInfo } from "../subscriptionPreferences/SubscriptionPreferencesModel";
import { IObjectScheme } from "@common/model/api/Datasources/IDataSourceScheme";

export const umSpPageStateSelector = (s: IState) =>
    s?.userManagement?.subscriptionPreferences;

export const umSpPageAuthSelector = (s: IState) =>
    umSpPageStateSelector(s)?.auth;

export const umSpPageDataSelector = (s: IState) =>
    umSpPageStateSelector(s)?.data;

export const umSpPageDynamicContentSelector = (s: IState) =>
    umSpPageStateSelector(s)?.dynamicContent;

export function umSpPageSubscriptionsTypesConsentsExtractor(
    subscriptionsTypes: ISubscriptionInfo[],
    scheme: IObjectScheme
): [any, string[]] {
    const sum = {
        smsconsent: false,
        emailconsent: false,
        pushconsent: false,
        postconsent: false,
    };

    const map: any = {};
    if (umSpPageHasSubscriptionsTableExtractor(scheme)) {
        for (const sType of subscriptionsTypes) {
            map[sType.id] = sType;
            for (const key of Object.keys(sum))
                sum[key] = sum[key] || Boolean(sType[key]);
        }
    } else {
        for (const consentKey of Object.keys(sum))
            sum[consentKey] = scheme?.Properties?.some(
                prop => prop.Name == consentKey && prop.EditorVisible
            );
    }
    return [map, Object.keys(sum).filter(k => sum[k])];
    //return [sum, Object.keys(sum).reduce((s, k) => (sum[k] ? s++ : s), 0)];
}

export const umSpPageSchemeSelector = (s: IState) =>
    umSpPageStateSelector(s)?.scheme;

export const umSpPageHasSubscriptionsTableSelector = (s: IState) =>
    umSpPageHasSubscriptionsTableExtractor(umSpPageSchemeSelector(s));

export const umSpPageHasSubscriptionsTableExtractor = (scheme: IObjectScheme) =>
    scheme?.Properties?.some(
        prop => prop.Name == "__usersubscriptions" && prop.Type == "Relation"
    ) || false;
